import React from "react";
import { Col, Row, Layout } from "antd";
import _ from "lodash";
import img from "../../assets/images/sajana-photo.jpg";
import useGetUserDetails from "../../hooks/useGetUserDetails";
import Header from "../../layout/protectedLayout/protectedLayoutStore/headers/pageHeader";

interface SkincareGuideInterface {}

const SkincareGuide: React.FC<SkincareGuideInterface> = () => {
  const userDetails: any = useGetUserDetails();

  return (
    <Layout>
      <Header hideSideNav={true} />
      <div className="skincare-guide-page">
        <h1 className="intro-title-mobile">Get To Know Your Skincare Guide </h1>
        <div className="skincare-guide-page__content">
          <Row gutter={[64, 16]} style={{ alignItems: "center" }}>
            <Col xs={24} md={12} lg={6}>
              <div className="left-section">
                <img src={img} alt="sajana_image" />
              </div>
            </Col>
            <Col xs={24} md={12} lg={18}>
              <div className="right-section">
                <h2 className="right-section__intro-title intro-title-dekstop">
                  Get To Know Your Skincare Guide
                </h2>
                <h2 className="right-section__intro">
                  Hi{" "}
                  {_.upperFirst(
                    userDetails?.userDetails?.user_information?.first_name
                  )}
                  ! I’m Sajana Shrestha.
                </h2>
                <p>Sharing a little bit about me with you :)</p> <br />
                <div className="right-section__about-me">
                  <ul>
                    <li>I got my Esthetician License in 2020.</li>
                    <li>
                      I have worked at: Sephora, OSEA, Ayla Beauty, BlueMercury,
                      Credo, Beautylish + more
                    </li>
                    <li>My Degree is Bachelors’ in Business Management</li>
                    <li>
                      This Extra Degree is my version of MBA: FIDM Beauty
                      Industry Marketing and Product Development
                    </li>
                    <li>
                      What caring means to me? {`-->`} We may look different,
                      but at the core we are the same— deeply interconnected to
                      each other. So, when I take care of you, I’m taking care
                      of us.
                    </li>
                  </ul>
                </div>
                <p>
                  I can’t wait to personally handcraft your skincare space, My
                  Dear Precious Star!
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
};

export default SkincareGuide;
